const DrawHitbox = ({ rawX, rawY, x, y, width, height, color = "red" }) => {
	const cornerDots = [
		{ left: x, top: y },
		{ left: x + width, top: y },
		{ left: x, top: y + height },
		{ left: x + width, top: y + height },
	];

	return null;

	return (
		<>
			{/* Raw center dot */}
			<div
				className={`absolute z-10 w-2 h-2 bg-${color}-500`}
				style={{ left: `${rawX}px`, top: `${rawY}px` }}
			/>
			{/* Box area */}
			<div
				className={`absolute z-10 bg-${color}-500 bg-opacity-10 border border-white`}
				style={{
					left: `${x}px`,
					top: `${y}px`,
					width: `${width}px`,
					height: `${height}px`,
				}}
			/>
		</>
	);
};

export default DrawHitbox;
